import get from 'lodash/get'

export function buildPageTitle ({ store, i18n, query = {} }) {
  const { siteType, siteName } = store.state

  const origin =
    query.originText ||
    query.originName ||
    query.origin ||
    get(store.state, 'flightsSearchFormData.originText') ||
    get(store.state, 'flightsSearchFormData.origin') ||
    ''

  if (!origin && !query.title && !query.toCode) return siteName || ''

  if (query.title) return query.title

  if (siteType === 'flights' && origin) {
    return [i18n.t('flights.meta.titleFrom'), origin].join(' ')
  }

  return siteName || ''
}
